import { TopicTypeEnum } from "../SuperEnum";
import Tools from "../Tools";
import ad_account from "../vo/dbvo/ad_account";
import ad_device from "../vo/dbvo/ad_device";
import ad_device_topic_map from "../vo/dbvo/ad_device_topic_map";
import ad_topic from "../vo/dbvo/ad_topic";

export type InputAddTopic = {
    /**
     * 主题名称
     */
    TopicName: string;
};

export type InputUpdateTopicName = {
    /**
     * 主题唯一
     */
    TopicUniqueIdentifier: string;
    /**
     * 主题名称
     */
    TopicName: string;
    /**
     * 筛选器
     */
    filter?: InputGetPublicTopicListFilter[]
};


export type InputGetPublicTopicList = {
    Page: number;
    PageSize: number;
    filter?: InputGetPublicTopicListFilter
};

export type InputGetPublicTopicListFilter = {
    TopicName?: string;
    TopicType?: TopicTypeEnum
};

export type InputSetTopicPermissions = {
    /**
     * 主题唯一索引
     */
    TopicUniqueIdentifier: string;
    /**
     * 是否公开
     */
    IsPublic: boolean;
    /**
     * 其它广告加入是否需要审核
     */
    NeedAudit: boolean
};

/**
 * 主题相关API
 */
export default class TopicApi {
    /**
     * 创建主题组
     * @param input 
     */
    public async AddTopicGroupAsync(input: InputAddTopic) {
        return Tools.FetchAsync<ad_topic>("Topic/AddTopicGroup", input, "POST");
    }

    /**
     * 修改主题名称
     */
    public async UpdateTopicNameAsync(input: InputUpdateTopicName) {
        return Tools.FetchAsync("Topic/UpdateTopicName", input, "PATCH");
    }

    /**
     * 获取公开主题列表
     * 用于设备的绑定(可绑定个人主题或组/联盟主题)
     */
    public async GetPublicTopicListAsync(input: InputGetPublicTopicList) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: {
                user: ad_account,
                topic: ad_topic
            }[]
        }>("Topic/GetPublicTopicList", input, "POST");
    }

    /**
     * 设置主题权限
     * @param input 
     * @returns 
     */
    public async SetTopicPermissions(input: InputSetTopicPermissions) {
        return Tools.FetchAsync("Topic/SetTopicPermissions", input, "PATCH");
    }

    /**
     * 删除主题
     * @param topicUniqueIdentifier 
     */
    public async RemoveTopicAsync(topicUniqueIdentifier: string) {
        return Tools.FetchAsync("Topic/RemoveTopic", {
            topicUniqueIdentifier
        }, "DELETE");
    }

    /**
     * 获取我的主题列表
     * @param page 
     * @param pageSize 
     * @param filterTopicType 
     */
    public async GetMyTopicListAsync(page: number, pageSize: number, filterTopicType?: TopicTypeEnum) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: ad_topic[]
        }>("Topic/GetMyTopicList", {
            page,
            pageSize,
            filterTopicType
        }, "GET");
    }

    /**
     * 获取设备上绑定的主题列表
     * @param deviceUniqueIdentifier 
     */
    public async GetTopicFromDeviceAsync(deviceUniqueIdentifier: string) {
        return Tools.FetchAsync<{
            device: ad_device,
            dlist: {
                adtm: ad_device_topic_map,
                topic: ad_topic
            }[]
        }>("Topic/GetTopicFromDevice", {
            deviceUniqueIdentifier
        }, "GET");
    }
}